export { default as EnCandidatePrivacyNotice } from './EnVersion';
export { default as FrCandidatePrivacyNotice } from './FrVersion';
export { default as NlCandidatePrivacyNotice } from './NlVersion';
export { default as DeCandidatePrivacyNotice } from './DeVersion';
